import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import ChannelVisibilityContainer from 'containers/dashboards/siteDirect/ChannelVisibilityContainer';
import GenericSiteDirectExpandContainer from 'containers/dashboards/siteDirect/GenericSiteDirectExpandContainer';
import { generateCalloutComponents } from 'helpers/componentGenerators';
import { getActivitiesSettings, getAudioObjectiveSettings } from 'helpers/objectiveSettings';

class AudioModule extends Component {
    render() {
        const { channel, ioChannel } = this.props;
        const stub = 'l3-site-audio';
        const { entityObjective } = this.props;
        const {
            eCPAActivitiesOrClicks, calloutTitle
        } = getActivitiesSettings(entityObjective);

        const hasCalloutData = get(this.props, 'channel.callouts.params.hasData', false);
        const callouts = get(this.props, 'channel.callouts.data', {});
        const calloutWindow = get(this.props, 'channel.callouts.params.timeRanges.previous.windowSize', null);

        // Data source can be ttd or dcm
        // Objective can be ecpa or ctr
        const dataSource = get(this.props, 'entityMeta.channelDataSources.audio', 'ttd');
        const {
            calloutSettings
        } = getAudioObjectiveSettings(dataSource, entityObjective, eCPAActivitiesOrClicks, calloutTitle);

        const calloutComponents = generateCalloutComponents({
            stub, calloutSettings, hasCalloutData, callouts, calloutWindow
        });

        return (
            <ChannelVisibilityContainer ioChannel={ioChannel} channel={channel}
                expandContainer={GenericSiteDirectExpandContainer}>
                {/* Call Outs */}
                <Row>
                    {calloutComponents}
                </Row>
            </ChannelVisibilityContainer>
        );
    }
}

AudioModule.propTypes = {
    channel: PropTypes.object,
    ioChannel: PropTypes.string
};


export default AudioModule;



// WEBPACK FOOTER //
// ./src/components/organisms/siteDirect/AudioModule.js